import { theme } from '@primer/react';
import deepmerge from './node_modules/deepmerge/dist/cjs.js';

var LTTheme = deepmerge(theme, {
  colorSchemes: {
    light: {
      colors: {
        fg: {
          accent: "#0969DA",
          disabled: "#8C959F",
          "default": "#1f2328",
          muted: "#59636e",
          subtle: "#6e7781",
          onEmphasis: "#fff"
        },
        switchTrack: {
          bg: "#EAEEF2",
          hoverBg: "hsla(210,24%,90%,1)",
          activeBg: "hsla(210,24%,88%,1)",
          disabledBg: "#818b98",
          fg: "#656d76",
          disabledFg: "#ffffff",
          border: "rgba(0,0,0,0)",
          checked: {
            bg: "#0969DA",
            hoverBg: "#0969DA",
            activeBg: "#0757BA",
            fg: "#ffffff",
            disabledFg: "#ffffff",
            border: "rgba(0,0,0,0)"
          }
        },
        switchKnob: {
          bg: "#fff",
          disabledBg: "#f6f8fa",
          border: "#868F99",
          checked: {
            bg: "#ffffff",
            disabledBg: "#f6f8fa",
            border: "#0969DA"
          }
        },
        text: {
          "default": "#24292F",
          muted: "#656D76",
          danger: "#CF222E",
          yellow: "#9A6700",
          subtle: "#6E7781"
        },
        toggle: {
          bg: "#cbcbcb"
        },
        border: {
          accentMuted: "#54AEFF66",
          muted: "hsla(210,18%,87%,1)",
          subtle: "rgba(31,35,40,0.15)",
          "default": "#d1d9e0",
          emphasis: "#6E7781",
          selected: "#F6F8FA",
          invisibleIconBtn: "#d4d4d4",
          invisibleBtn: "transparent",
          danger: "transparent",
          lightGray: "#D8DEE4"
        },
        actionListItem: {
          inlineDivider: "rgba(208,215,222,0.48)",
          "default": {
            activeBg: "#818b9826",
            border: "transparent",
            selectedBg: "rgba(208,215,222,0.24)",
            selectedBorder: "transparent",
            hoverBg: "#818b981a"
          }
        },
        counterLabel: {
          defaultText: "#333"
        },
        focus: {
          "default": "#D4D4D4",
          muted: "#0969da",
          outlineColor: "#0969DA"
        },
        flashDefault: {
          muted: "#54AEFF",
          subtle: "#DDF4FF"
        },
        success: {
          bg: "#176F2C",
          emphasis: "#1F883D",
          muted: "rgba(74,194,107,0.4)",
          subtle: "#dafbe1"
        },
        attention: {
          muted: "rgba(212,167,44,0.4)",
          subtle: "#FFF8C5"
        },
        danger: {
          bg: "#CF222E",
          muted: "rgba(255,129,130,0.4)",
          subtle: "#FFEBE9"
        },
        warning: {
          bg: "#9A6700"
        },
        "default": {
          muted: "#54aeff66",
          subtle: "#DDF4FF"
        },
        slate: {
          bg: "#EAEEF2"
        },
        btn: {
          text: "#24292f",
          bg: "#f6f8fa",
          border: "rgba(31,35,40,0.15)",
          hoverBg: "#eff2f5",
          hoverBorder: "#d1d9e0",
          activeBg: "#e6eaef",
          activeBorder: "#d1d9e0",
          selectedBg: "hsla(220,14%,94%,1)",
          counterBg: "rgba(31,35,40,0.08)",
          primary: {
            bg: "#1F883D",
            border: "#1F232826",
            disabledBg: "#95D8A6",
            disabledBorder: "#95D8A6",
            focusBorder: "#0969DA",
            hoverBg: "#1C8139",
            selectedBg: "#197935",
            text: "#fff"
          },
          "default": {
            bg: "#F6F8FA",
            border: "#D0D7DE",
            disabledBg: "#F6F8FA",
            disabledText: "#8C959F",
            focusBorder: "#0969DA",
            hoverBg: "#F6F8FA",
            hoverText: "#24292F",
            selectedText: "#24292F",
            selectedBg: "#E7EBEF",
            text: "#25292e"
          },
          danger: {
            bg: "#F6F8FA",
            border: "#D0D7DE",
            disabledBg: "#F6F8FA",
            disabledText: "#D1242F80",
            disabledBorder: "#1F23280A",
            focusBorder: "#0969DA",
            hoverBg: "#A40E26",
            selectedBg: "#8B0820",
            text: "#D1242F"
          },
          invisible: {
            activeBg: "#818b9826",
            bg: "#FFFFFF",
            disabledBg: "#EAEEF2B2",
            disabledText: "#8C959F",
            focusBorder: "#0969DA",
            hoverBg: "#818b981a",
            selectedBg: "#818b9826",
            text: "#24292F"
          },
          outline: {
            bg: "#F6F8FA",
            border: "#D0D7DE",
            disabledBg: "#F6F8FA",
            disabledText: "#8C959F",
            disabledBorder: "#EAEEF2B2",
            focusBorder: "#0969DA",
            hoverBg: "#F6F8FA",
            hoverText: "#24292F",
            selectedText: "#24292F",
            selectedBg: "#E7EBEF",
            text: "#24292F"
          }
        },
        link: {
          "default": "#0969DA",
          hover: "#0969DA"
        },
        accent: {
          fg: "#0969DA",
          muted: "#DDF4FF",
          emphasis: "#0969DA"
        },
        blueAccent: {
          emphasis: "#0969DA",
          fg: "#0969DA",
          muted: "#0862C9",
          bg: "#DDF4FF",
          hoverBg: "#c5eafc",
          border: "#ddebf1"
        },
        checked: {
          bg: {
            checked: "#0969DA",
            disabled: "#8C959F"
          }
        },
        bg: {
          accentEmphasis: "#0969DA",
          attentionEmphasis: "#9A6700",
          closedEmphasis: "#CF222E",
          doneEmphasis: "#8250DF",
          disabled: "#EAEEF2B2",
          "default": "#fff",
          selected: "#818b9826",
          muted: "#F6F8FA",
          neutralMuted: "#818b981f",
          neutralEmphasis: "#6E7781",
          severeEmphasis: "#BC4C00",
          successEmphasis: "#1F883D"
        },
        timeline: {
          badgeBg: "#eaeef2",
          badgeBorder: "#fff"
        },
        control: {
          borderColor: {
            disabled: "#EAEEF2B2"
          }
        },
        onHover: "#F7F7F7",
        onSelected: "#F0F0F0",
        highlight: "#ED5F00"
      },
      shadows: {
        btn: {
          insetShadow: "0px 1px 0px 0px #1B1F230A"
        }
      }
    },
    light_high_contrast: {
      colors: {
        fg: {
          disabled: "#888",
          "default": "#333",
          muted: "#666",
          subtle: "#dddddd33",
          onEmphasis: "#fff"
        },
        switchTrack: {
          bg: "#ededed",
          hoverBg: "#ededed",
          activeBg: "#ededed",
          disabledBg: "#666666",
          fg: "#656d76",
          disabledFg: "#ffffff",
          border: "#888",
          checked: {
            bg: "#101010",
            hoverBg: "#101010",
            activeBg: "#101010",
            fg: "#ffffff",
            disabledFg: "#ffffff",
            border: "#101010"
          }
        },
        switchKnob: {
          bg: "#ffffff",
          disabledBg: "#ffffff",
          border: "#888888",
          checked: {
            bg: "#ffffff",
            disabledBg: "#ffffff",
            border: "#101010"
          }
        },
        toggle: {
          bg: "#888888"
        },
        text: {
          "default": "#333333",
          muted: "#666666",
          danger: "#CF222E",
          yellow: "#947100",
          subtle: "#6E7781"
        },
        counterLabel: {
          defaultText: "#fff"
        },
        border: {
          "default": "#D0D7DE",
          invisibleIconBtn: "#888",
          invisibleBtn: "#888",
          danger: "FFEBE9",
          muted: "#d1d9e0b3",
          primaryBtn: "transparent",
          primaryBtnDisabled: "#888888",
          rest: "#d1d9e0",
          lightGray: "#888888"
        },
        focus: {
          "default": "#D4D4D4",
          muted: "#0969da",
          outlineColor: "#101010"
        },
        flashDefault: {
          muted: "#54AEFF",
          subtle: "#DDF4FF"
        },
        success: {
          bg: "#176F2C",
          muted: "#A0E5B2",
          subtle: "#DAFAE1"
        },
        attention: {
          muted: "#D4A72C",
          subtle: "#FFF8C5"
        },
        danger: {
          bg: "#CF222E",
          muted: "#FF8182",
          subtle: "#FFEBE9"
        },
        warning: {
          bg: "#9A6700"
        },
        "default": {
          muted: "#54aeff66",
          subtle: "#DDF4FF"
        },
        slate: {
          bg: "#666666"
        },
        icon: {
          "default": "#888888"
        },
        actionListItem: {
          "default": {
            activeBg: "#F0F0F0",
            selectedBg: "#F0F0F0",
            selectedBorder: "#101010",
            border: "#888",
            hoverBg: "#dddddd33"
          },
          danger: {
            hoverBg: "rgba(255,235,233,0.64)",
            hoverText: "#d1242f"
          }
        },
        btn: {
          bg: "#f7f7f7",
          hoverBg: "rgb(243, 244, 246)",
          primary: {
            bg: "#1f883d",
            border: "#1f232826",
            text: "#fff",
            hoverBg: "#1c8139",
            disabledBg: "#94d3a2",
            activeBg: "#F7F7F7"
          },
          "default": {
            border: "#d1d9e0",
            bg: "#f6f8fa",
            text: "#25292e",
            hoverBg: "#eff2f5",
            disabledBg: "#eff2f5",
            activeBg: "#e6eaef"
          },
          danger: {
            bg: "#F7F7F7",
            disabledBg: "#f6f8fa",
            hoverBg: "#a40e26"
          },
          invisible: {
            disabledBg: "#888888",
            hoverBorder: "#888"
          },
          outline: {
            bg: "#333333",
            text: "#101010",
            hoverBg: "#0969da",
            hoverBorder: "rgba(31,35,40,0.15)",
            hoverText: "#ffffff",
            disabledBg: "#F7F7F7"
          }
        },
        link: {
          "default": "#0969DA",
          hover: "#0969DA"
        },
        accent: {
          fg: "#333333",
          muted: "#DDF4FF",
          emphasis: "#101010"
        },
        blueAccent: {
          emphasis: "#0969DA",
          fg: "#0969DA",
          bg: "#DDF4FF",
          hoverBg: "#c5eafc",
          border: "#ddebf1"
        },
        checked: {
          bg: {
            checked: "#0969DA"
          }
        },
        bg: {
          muted: "#F7F7F7",
          neutralEmphasis: "#666",
          light: "#DDDDDD"
        },
        tooltipText: {
          bg: "#24292F"
        },
        timeline: {
          badgeBg: "#e7ecf0",
          badgeBorder: "#888"
        },
        onHover: "#F7F7F7",
        onSelected: "#F0F0F0",
        highlight: "#ED5F00"
      },
      shadows: {
        btn: {
          insetShadow: "0px 1px 0px 0px #1B1F230A"
        }
      }
    },
    dark: {
      colors: {
        text: {
          "default": "#e6edf3",
          muted: "#7d8590",
          onEmphasis: "#fff",
          subtle: "#6e7681"
        },
        border: {
          "default": "#3d444d"
        },
        btn: {
          bg: "#212830",
          border: "#3d444d",
          focusBorder: "#4493f8",
          hoverBg: "#262c36",
          selectedBg: "#2a313c",
          text: "#fff",
          "default": {
            bg: "#212830",
            border: "#3d444d",
            focusBorder: "#4493f8",
            hoverBg: "#262c36",
            selectedBg: "#2a313c",
            text: "#fff"
          },
          invisible: {
            bg: "#212830",
            border: "#3d444d",
            focusBorder: "#4493f8",
            hoverBg: "#262c36",
            selectedBg: "#2a313c",
            text: "#fff"
          }
        },
        slate: {
          bg: "#262c36"
        },
        fg: {
          muted: "#A5A09B"
        },
        focus: {
          outlineColor: "#4493f8"
        }
      }
    }
  }
});

export { LTTheme as default };
